module.exports = __webpack_public_path__ + "static/img/14010203.35002dc3.png";